
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadtrip-guide-directory",
      function () {
        return require("private-next-pages/roadtrip-guide-directory.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadtrip-guide-directory"])
      });
    }
  